import { S as Swiper } from './swiper-core-BHOuL--z.js';
import { A as Autoplay } from './autoplay-B3VtpnqN.js';
import './utils-DWOYB00a.js';

class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    new Swiper(this, {
      modules: [Autoplay],
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1024: {
          spaceBetween: 32,
          slidesPerView: 'auto',
          loop: false,
          autoplay: false,
          allowTouchMove: false,
        },
      },
    });
  }
}

customElements.define('announcement-bar', AnnouncementBar);
